export default "__VITE_ASSET__LCPcn1mi__"